<template>
    <div class="row">
        <div class="col-12 col-md-12 acountStatus">
            <div class="whiteBG pt-3 border supportpagetab radius mb-3">
                <div class="d-flex justify-content-between border-bottom pb-3 px-3 mb-2">
                    <div></div>
                    <filter-component></filter-component>
                </div>
                <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
                <div class="mapIco-list-table mt-4">
                    <div class="tablePmm">
                        <table class="table pmmTable" >
                            <thead>
                                <tr>
                                    <th>{{$t('ticketNumber')}}</th>
                                    <th>{{$t('reason')}}</th>
                                    <th>{{$t('created')}}</th>
                                    <th>{{$t('action')}}</th>
                                </tr>
                            </thead>
                            <tbody v-if="(!pageLoader && ticketList != '' && ticketList.totalRecords > 0)">
                                <tr v-for="list in ticketList.records">
                                    <td>{{list.ticket}}</td>
                                    <td>
                                        <p v-if="ticketReasonList[list.reason] && ticketReasonList[list.reason].categories && parseInt(list.title) != 0">
                                            <label v-for="catlist in ticketReasonList[list.reason].categories" v-if="catlist.id == list.title"> {{catlist.title}}</label>
                                        </p>
                                        <p v-else-if="ticketReasonList[list.reason]">
                                            {{ticketReasonList[list.reason].title}}
                                        </p>
                                        <p v-else>-</p>
                                    </td>
                                    <td>{{list.created | moment("dddd DD MMMM, YYYY")}}</td>
                                    <td> 
    				                	<router-link :to="{name: 'fxView.view' , query: { 'id':list.id}}" class="prism_btn width_xs btn_xs green_btn" title="View" data-placement="top"  data-toggle="tooltip">
                                            {{$t('viewTicket')}}
                                        </router-link>
    				               	</td>
                                </tr>
                            </tbody>
                            <loader-component :pageloader_value="pageLoader" :type="'table'" :colspan="col_span" :list="ticketList" v-else></loader-component>
                        </table>
                        
                    </div>
                </div> 
            </div>
            <pagination :getList="ticketList" :limit="pageLimit" v-if="ticketList.totalRecords > 0"></pagination>
        </div>
    </div>
     
</template>
<script> 
	import { fxViewMixins } from '@/plugins/fxView'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
	export default {
		name: 'OPEN-TICKET',
		mixins: [fxViewMixins],
		data () {
			return {
                //===========prop in loader component=======
                col_span : 4,
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                loaderFuncRun : '1',
                //==========================================
				page : '1',
                search : '',
                pageLimit : '15'
			}
		},
        props:['pageLim'],
		methods:{
            listing(){
                let input_json={
                    'globalParams' :{
                        filter: {},
                        sort: [],
                        search: this.search,
                        page: this.page,
                        perPage: parseInt(this.pageLimit),
                        'status' : this.$parent.ticket_status
                    },
                    'localParams' :{ "parameter" : this ,'loaderFuncRun' : this.loaderFuncRun}
                }
                this._runGetTicketList(input_json)
            }
		},
		created(){
            if(this.$store.getters[Const.GET_TICKET_LIST] != ''){
                this.loaderFuncRun = '0'
            }
			this.listing()
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/supports/support.vue